// extracted by mini-css-extract-plugin
export default {"heroText":"main_heroText__NnRyU","heroImage":"main_heroImage__aj07k","statusSigner":"main_statusSigner__7t+Bb","status":"main_status__eMniP"};